import { b as _arrayLikeToArray, c as _unsupportedIterableToArray, _ as _defineProperty, a as _slicedToArray, I as IconConfigContext } from './dep-50ece1d9.js';
import { useState, useContext, useEffect } from 'react';
import useSizeProps from '../util/use-size-props.js';

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getDefaultExportFromNamespaceIfPresent (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') ? n['default'] : n;
}

function getDefaultExportFromNamespaceIfNotNamed (n) {
	return n && Object.prototype.hasOwnProperty.call(n, 'default') && Object.keys(n).length === 1 ? n['default'] : n;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var classnames = {exports: {}};

/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;
	var nativeCodeString = '[native code]';

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
					classes.push(arg.toString());
					continue;
				}

				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ('object' !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (typeof undefined === 'function' && typeof undefined.amd === 'object' && undefined.amd) {
		// register as 'classnames', consistent with npm package name
		undefined('classnames', [], function () {
			return classNames;
		});
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useApiProps = function useApiProps(props) {
  var colors = props.colors,
    color = props.color,
    className = props.className,
    hover = props.hover,
    size = props.size,
    disabled = props.disabled,
    initColor = props.initColor,
    initName = props.initName,
    style = props.style;
  var _useState = useState(initColor),
    _useState2 = _slicedToArray(_useState, 2),
    _color = _useState2[0],
    setColors = _useState2[1];
  var defalutColor = initColor;
  var _useSizeProps = useSizeProps(size),
    sizeClassName = _useSizeProps.className,
    _sizeStyle = _useSizeProps.style;
  var _useContext = useContext(IconConfigContext),
    classPrefix = _useContext.classPrefix;
  var sizeStyle = _objectSpread(_objectSpread({}, _sizeStyle), style);
  var cls = classNames("".concat(classPrefix, "-icon"), className, "".concat(classPrefix, "-icon-").concat(initName), sizeClassName, "".concat(hover !== "" ? classPrefix + "-cursor" : ""), "".concat(disabled ? classPrefix + "-disabled" : ""));
  useEffect(function () {
    if (typeof colors === "string" && initName.indexOf("-colored") === -1) {
      var col = _toConsumableArray(defalutColor);
      col[0] = colors;
      setColors(col);
    }
    if (colors instanceof Array && initName.indexOf("-colored") === -1) {
      var colorList = _toConsumableArray(defalutColor);
      colors.forEach(function (col) {
        var findColorIndex = colorList.findIndex(function (v) {
          return v === col.targetColor;
        });
        if (findColorIndex >= 0) {
          colorList[findColorIndex] = col.reviseColor;
        }
      });
      setColors(_toConsumableArray(colorList));
    }
    if (color && typeof color === "string" && initName.indexOf("-colored") === -1) {
      var _col = _toConsumableArray(defalutColor);
      _col[0] = color;
      setColors(_col);
    }
  }, [JSON.stringify(colors), color]);
  return {
    colorList: _color,
    sizeStyle: sizeStyle,
    cls: cls,
    setColors: setColors
  };
};

export { _toConsumableArray as _, useApiProps as u };
//# sourceMappingURL=dep-f0ef67c3.js.map
